import builder from '../builder';
import TimeClockFileCash from '../../streamline-icons/bold/time-clock-file-cash.svg';

export default builder('IconTimeClockFileCashBold', TimeClockFileCash);
